import BaseModal from "..";
import HNSColors from "../../../HNSColors";
import { SvgEnum } from "../../svgs/standard/svg";
import { getButtonsConfig } from "../modalButtonsConfig";

/**
 * @param {Object[]} params.buttons // buttons must be in order
 * button object:
 *  - label: string
 *  - onClick: function
 *  - type: 'cancel' | 'delete' | 'back' | 'ok'
 */

export default function WarningModal({ title = "Warning", message = "", buttons = [] }) {
  const BUTTONS = getButtonsConfig(buttons);

  return (
    <BaseModal
      iconName={SvgEnum.HisAlertCircle}
      iconColor={HNSColors.warning[600]}
      iconBgColor={HNSColors.warning[700]}
      title={title}
      titleColor={HNSColors.warning[600]}
      message={message}
      buttons={BUTTONS}
    />
  );
}
